import Api from "../apiService";

class usersApi {
  currentUser(params = {}) {
    return Api.getRequest(`users/current`, params, Api.authHeaders());
  }

  changeCurrentCompany(newCompanyId) {
    return Api.patchRequest(
      `users/change_current_company`,
      { company_id: newCompanyId },
      Api.authHeaders()
    );
  }

  index(companyId, params = {}) {
    return Api.getRequest(
      `companies/${companyId}/users`,
      params,
      Api.authHeaders()
    );
  }

  show(companyId, userId, params = {}) {
    return Api.getRequest(
      `companies/${companyId}/users/${userId}`,
      params,
      Api.authHeaders()
    );
  }

  create(companyId, userData) {
    return Api.postRequest(
      `companies/${companyId}/users`,
      userData,
      Api.authHeaders()
    );
  }

  update(companyId, userId, userData) {
    return Api.patchRequest(
      `companies/${companyId}/users/${userId}`,
      userData,
      Api.authHeaders()
    );
  }

  delete(companyId, userId) {
    return Api.deleteRequest(
      `companies/${companyId}/users/${userId}`,
      Api.authHeaders()
    );
  }

  changePassword(userData) {
    return Api.patchRequest(
      `/users/change_password`,
      userData,
      Api.authHeaders()
    );
  }

  sendRecoveryToken(token) {
    return Api.postRequest("/users/send_recovery_token", token);
  }

  recoveryPassword(recoveryData) {
    return Api.patchRequest(`/users/recovery_password`, recoveryData);
  }
}

export default new usersApi();
